module.exports = __webpack_public_path__ + "img/satori komeiji_lw.fe40684f.png";